CheckMemberImages();
$(function () {
	CheckMemberImages();
});

function CheckMemberImages() {
	$("img.member-card__image").each(function () {
		if (this.naturalWidth === 0 && this.complete) {
			$(this).prop("src", require("../img/MissingMemberImage.jpg"));
		}
	});
}

